
// createApp(App).use(store).use(router).mount('#app')
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import { VDataTable } from 'vuetify/components'



// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

// BootstrapVueNext completo
import { createBootstrap } from 'bootstrap-vue-next'
import { BTableLite, BBadge, BButton, BContainer, BPagination } from 'bootstrap-vue-next'

// SweetAlert2
import { Swal, Toast, SwalVVMonE } from './plugins/sweetalert'
import 'sweetalert2/dist/sweetalert2.min.css'
import './assets/styles/sweetalert-custom.css'

import notificationService from '@/services/notificationService' 

const vuetify = createVuetify({
  components: {
    ...components,
    VDataTable,    
  },
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#007BFF',
          secondary: '#1E90FF',
          accent: '#0056D2',
        },
      },
    },
  },
})




const app = createApp(App)

// Registrar BootstrapVueNext
app.use(createBootstrap())

app.component('BTableLite', BTableLite)
app.component('BBadge', BBadge)
app.component('BButton', BButton)
app.component('BContainer', BContainer)
app.component('BPagination', BPagination)

// IMPORTANTE: Restaurar el estado antes de montar la app
store.dispatch('restoreState')

// Hacer SweetAlert2 disponible globalmente
app.config.globalProperties.$swal = Swal
app.config.globalProperties.$toast = Toast
app.config.globalProperties.$swalVVMonE = SwalVVMonE

app.use(store)
app.use(router)
app.use(vuetify)

app.config.globalProperties.$notificationService = notificationService

app.mount('#app')
